import { observable } from "mobx";
import { api } from "../../api";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import moment from "moment";
import { CentralStore } from "./CentralStore";

export class _ErrosNotasStore {

  obs = observable({
    selectedPeriod: [moment().startOf('month').toDate(), moment().endOf('month').toDate()] as any,
    selectedEmpresa: newEmpresa() as IEmpresa,
    date1: "" as string,
    date2: "" as string,
    imports_page: 1,
    imports: [],
    imports_length: 0,
    erros: true as boolean,
    avisos: true as boolean
  })

  setPeriodoAndEmpresa(period: any, empresa: IEmpresa) {
    this.obs.selectedEmpresa = empresa;
    this.obs.selectedPeriod = period;
  }

  async handleBuscaImportacoes(page: number, empresa: any, date1: string, date2: string, erros: boolean, avisos: boolean): Promise<void> {

    try {
      let params = {
        empresa: empresa,
        data1: date1,
        data2: date2,
        page: page,
        limit: 20,
        erros: erros,
        avisos: avisos
      }

      let resp = await api.post("/api/busca_importacoes", params)

      this.obs.imports = [];
      this.obs.imports_length = 0;

      if (resp.data.itens.length > 0) {
        this.obs.imports = resp.data.itens
        this.obs.imports_length = resp.data.count

      } else {
        toast.warning('Não foram encontrados resultados.', {});
      }

    } catch (ex) {
      toast.error("Erro ao buscar notas erros, tente novamente mais tarde.", {});
    }

  }

  async handleImpotErros(page: number, importacao_id: string) {

    try {

      let data = {
        importacao_id: importacao_id,
        page: page,
        limit: 20
      }

      let resp = await api.post(`/api/busca_importacoes_erros`, data)

      if (resp.data.length) {

        return resp.data

      }
    } catch (ex) { }

    return []
  }

  async handleImpotAvisos(page: number, importacao_id: string) {

    try {

      let data = {
        importacao_id: importacao_id,
        page: page,
        limit: 20
      }

      let resp = await api.post(`/api/busca_importacoes_avisos`, data)

      if (resp.data.length) {

        return resp.data

      }

    } catch (ex) { }

    return []

  }

  /**
 * Função assíncrona para remover erros de importações através de uma requisição API.
 * 
 * A função envia uma lista de IDs de erros para a API para serem removidos. Se a remoção for bem-sucedida, retorna `true`. 
 * Caso contrário, exibe uma mensagem de erro. Se ocorrer uma falha na requisição, exibe uma mensagem genérica de erro.
 * 
 * @async
 * @function handleRemoveErros
 * 
 * @param {string[]} ids - Lista de IDs de erros a serem removidos.
 * 
 * @returns {Promise<boolean>} Retorna `true` se a remoção for bem-sucedida, ou `false` em caso de falha.
 */
  async handleRemoveErros(ids: string[]) {

    try {

      let data = {
        ids: ids
      }

      let resp = await api.post(`/api/busca_importacoes/delete`, data)

      if (resp.data.ok) {

        toast.success("Erros removidos com sucesso!", {})

        CentralStore.obs.total_nao_calculado = resp.data.total

        return true

      } else {

        toast.error(resp.data.msg, {})

      }

    } catch (ex) {

      toast.error("Não foi possível remover erros de Cálculo, tente novamente mais tarde!", {})

    }

    return false

  }

}

export const ErrosNotasStore = new _ErrosNotasStore();
